export default {
  navigationBarTitleText: '线索管理'
};
